import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const SubscribersInfrastructureAutomationSave = createAsyncThunk(
    "SubscribersInfrastructureAutomationSave",
    async (data, { dispatch }) => {
        try {
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.SUBSCRIBERSINFRASTRUCTUREAUTOMATION.SAVE,
                    body: data,
                },
                true
            );
            let response = apiResponse(true, resData);

            return response;
        } catch (error) { }
    }
);

export const GetBySubscriber = createAsyncThunk(
    "GetBySubscriber",
    async (data, { dispatch }) => {
        try {
            let status = "";
            if (typeof data === "string") {
                status = data;
            } else if (data && typeof data === "object" && data.status !== undefined && data.status !== null) {
                status = data.status;
            }
            const queryParam = status ? `?status=${encodeURIComponent(status)}` : "";
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.SUBSCRIBERSINFRASTRUCTUREAUTOMATION.GETBYSUBSCRIBER + queryParam,
                    body: {},
                },
                false
            );
            let response = apiResponse(false, resData);

            return response;
        } catch (error) { }
    }
);

export const Delete = createAsyncThunk(
    "Delete",
    async (data, { dispatch }) => {
        try {
            const queryParam = data ? `?subscribersinfrastructureautomationid=${data?.subscribersinfrastructureautomationid || data}` : "";
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.SUBSCRIBERSINFRASTRUCTUREAUTOMATION.DELETE + queryParam,
                    body: {},
                },
                false
            );
            let response = apiResponse(true, resData);

            return response;
        } catch (error) { }
    }
);

export const GetRunningLog = createAsyncThunk(
    "GETRUNNINGLOG",
    async (data, { dispatch }) => {
        try {
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.SUBSCRIBERSINFRASTRUCTUREAUTOMATION.GETRUNNINGLOG,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);

            return response;
        } catch (error) { }
    }
);


const initialState = {
    SubscribersInfrastructureAutomationSaveData: {
        data: null,
        error: null,
    },
    GetBySubscriberData: {
        data: null,
        error: null,
    },
    DeleteData: {
        data: null,
        error: null,
    },
    GetRunningLogData: {
        data: null,
        error: null,
    },
};

const SubscribersInfrastructureAutomation = createSlice({
    name: " SubscribersInfrastructureAutomation",
    initialState,
    reducers: {
        setSubscribersInfrastructureAutomation: (state) => {
            state.GetSubscriberProfileData.data = null;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(SubscribersInfrastructureAutomationSave.fulfilled, (state, action) => {
                state.SubscribersInfrastructureAutomationSaveData.data = action.payload;
            })
            .addCase(SubscribersInfrastructureAutomationSave.rejected, (state, action) => {
                state.SubscribersInfrastructureAutomationSaveData.error = action.error.message;
            })
            .addCase(GetBySubscriber.fulfilled, (state, action) => {
                state.GetBySubscriberData.data = action.payload;
            })
            .addCase(GetBySubscriber.rejected, (state, action) => {
                state.GetBySubscriberData.error = action.error.message;
            })
            .addCase(Delete.fulfilled, (state, action) => {
                state.DeleteData.data = action.payload;
            })
            .addCase(Delete.rejected, (state, action) => {
                state.DeleteData.error = action.error.message;
            })
            .addCase(GetRunningLog.fulfilled, (state, action) => {
                state.GetRunningLogData.data = action.payload;
            })
            .addCase(GetRunningLog.rejected, (state, action) => {
                state.GetRunningLogData.error = action.error.message;
            });
    },
});

export const { setSubscribersInfrastructureAutomation } = SubscribersInfrastructureAutomation.actions;
export default SubscribersInfrastructureAutomation.reducer;
